import Backbone from 'backbone'

var SourceExclusion = Backbone.Model.extend({
});

export default SourceExclusion;

